import { CollectionPageJsonLd } from 'next-seo'
import ListingsTemplate from '@/components/Blog/BlogListings/ListingsTemplate'
import { getAllArticlesForSearch } from '@/utils/getArticles'
import { getBlogByHandle, getBlogSettings } from '@/utils/getBlogs'
import { getCookingClassCategoryDataByHandle } from '@/utils/getCookingClassCategoryData'
import { getSanityClient } from '@/services/sanityClient'
import groq from 'groq'
import { PreviewButton } from '@/components/Preview/PreviewButton'
import PageSEO from '@/components/SEO/PageSEO'

const RecipeListings = ({ blogSettings, page, articles, preview, previewToken }) => {
  const categoryUrl = `${process.env.NEXT_PUBLIC_DOMAIN}/blogs/culinary/${page.handle.current}`

  console.log('Culinary Category Page - SEO Data:', {
    category: page.handle.current,
    seo: page.fields?.seo,
    title: page.fields?.seo?.metaTitle,
    description: page.fields?.seo?.metaDesc,
    heroImage: page.fields?.hero?.desktopBackgroundImage?.asset?.url,
    articlesCount: articles?.length,
    featuredClass: page.fields?.featuredClass ? true : false
  })

  if (page.fields.featuredClass) {
    page.fields.hero = page.fields.featuredClass.hero
  }

  return (
    <>
      {preview && previewToken && <PreviewButton />}
      <PageSEO
        seo={page.fields.seo}
        images={page.fields?.hero?.desktopBackgroundImage ? [{
          url: page.fields.hero.desktopBackgroundImage.asset.url,
          alt: page.fields.hero.header || ''
        }] : []}
      />
      <CollectionPageJsonLd
        name={page.fields?.seo?.metaTitle || page.title}
        description={page.fields?.seo?.metaDesc || ''}
        url={categoryUrl}
        hasPart={articles.map(article => ({
          "@type": "Article",
          headline: article.title,
          url: `${process.env.NEXT_PUBLIC_DOMAIN}/blogs/culinary/${page.handle.current}/${article.handle.current}`,
          datePublished: article.publishedDate || article.createdAt,
          image: article.fields?.hero?.desktopBackgroundImage?.asset?.url || null
        }))}
      />
      <ListingsTemplate articles={articles} blogSettings={blogSettings} page={page} />
    </>
  )
}

export default RecipeListings

export async function getStaticPaths() {
  const blogs = await getSanityClient().fetch(
    groq`*[_type in ["blog", "cookingClassCategory"]]{ blogType, handle { current } }`
  )
  const handles = blogs
    .filter(b => b.blogType === 'culinary')
    .map((page) => ({ params: { category: page.handle.current } }))

  return {
    paths: handles,
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params, draftMode }) {
  const preview = draftMode || false;
  const previewToken = preview ? process.env.SANITY_READ_TOKEN : ``;
  if (preview && !previewToken) {
    throw new Error(`Preview mode is active, but SANITY_READ_TOKEN is not set in environment variables`);
  }

  const sanityClient = getSanityClient(previewToken)

  const [blog, cookingClassCategoryBlog, blogSettings] = await Promise.all([
    getBlogByHandle(params.category, sanityClient),
    getCookingClassCategoryDataByHandle(params.category, sanityClient),
    getBlogSettings(sanityClient)
  ])
  if (!blog && !cookingClassCategoryBlog) {
    return {
      notFound: true
    }
  }

  const page = blog ? blog : cookingClassCategoryBlog

  const articles = await getAllArticlesForSearch(page, params.category)

  if (!articles || articles.length < 1) {
    // throw new Error(`No articles found when building blogs/culinary/${params.category}`)
  }

  return {
    props: {
      blogSettings,
      page: page,
      handle: page.handle,
      articles,
      preview,
      previewToken
    }
  }
}